import { useEffect, useState } from 'react';
import { NavLink, useSearchParams } from "react-router-dom";
import LoggedLayout from 'layouts/LoggedLayout';
import axios from 'axios';
import styled from 'styled-components';
import Paginator from 'components/Paginator';
import ThSortable from 'components/ThSortable';
import TrSkeleton from 'components/TrSkeleton';
import { hasCapability } from 'helpers/user';

const Filters = styled.div`
	display: flex;
	justify-content: end;

	@media (max-width: 1200px) {
		justify-content: center;
		flex-direction: column;

		& > *,
		.empowered-selector {
			width: 100% !important;
			display: block !important;
		}

		& > * {
			margin-bottom: 10px;
		}
	}
`;

let axiosCancelToken = null;
let searchTimeout = null;

export default function Users() {
	const [queryParams] = useSearchParams();

	let [users, setUsers] = useState([]);
	let [sortDirection, setSortDirection] = useState('desc');
	let [sortField, setSortField] = useState('name');
	let [search, _setSearch] = useState(null);
	let [skeletonRows, setSkeletonRows] = useState(5);
	let [page, _setPage] = useState(queryParams.get('page') ?? undefined);
	const setPage = (page) => {
		setUsers({...users, data: undefined});
		_setPage(page);
	}
	const setSearch = (value) => {
		if ( searchTimeout ) clearTimeout(searchTimeout);
		searchTimeout = setTimeout(() => {
			_setSearch(value);
		}, 500);
	}
 
	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		const getUsers = async () => {
			return axios.get('api/users/list', {
				params: {
					page: page,
					sort: sortField,
					direction: sortDirection,
					search: search,
				},
				cancelToken: axiosCancelToken.token
			}).then((response) => {
		    	setUsers({...response.data});
		    	setSkeletonRows(response.data.data.length);
		  	}).catch((error) => {
				if ( axios.isCancel(error) ) return;
			});
		}

		getUsers();

		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, [page, sortDirection, sortField, search]);

	const sortTableClick = (field) => {
		if ( !field ) return;
		if ( field === sortField ) setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
		setSortField(field);
	};	

	return (
		<LoggedLayout>
			<div className="col-md-12 mb-3">
				<div className="bg-white p-2 rounded shadow-sm">
					<div className="row">
						<div className="col-lg-2 align-content-center">
							Listado de usuarios
						</div>
						<Filters className="col-md-10 gap-2">
							<input type="search" placeholder="Buscar" className="form-control form-control_flotas control-input h-100" style={{ minWidth: '165px', width: 'auto'}} onChange={(e) => setSearch(e.target.value)} />
							{ hasCapability('users', 'add') &&
								<NavLink to="/users/add" className="btn btn-sm btn-plenoil-light btn-plenoil p-0 px-2 d-inline-flex align-items-center justify-content-center text-nowrap col-4 col-lg-auto">Añadir</NavLink>
							}
						</Filters>
					</div>
				</div>
			</div>

			<div className="pt-2 col-md-12">
				<div className="px-0 col-lg pl-lg-0">
					<div className="row m-0 pb-2">
						<div className="col-12 px-0">
							<div className="h-100 p-4 background-color-blanco shadow rounded">
								<div className="table-responsive-rows">
									<div className="mvc-grid mvc-grid-header-mode">
										<div className="mvc-grid-table">
											<table>
												<thead>
													<tr>
														<ThSortable className="title_usuarios-nombre" direction={sortDirection} active={sortField === 'name'} onClick={() => sortTableClick('name')}>Nombre</ThSortable>
														<ThSortable className="title_usuarios-email" direction={sortDirection} active={sortField === 'email'} onClick={() => sortTableClick('email')}>Email</ThSortable>
														<th></th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{ users.data?.map((el, idx) => {
														return (
															<tr key={idx}>
																<td className="title_usuarios-nombre">{el.name}</td>
																<td className="title_usuarios-email">{el.email}</td>
																<td></td>
																<td>
																	<NavLink to={'/users/edit/' + el.id}><i className="bi bi-pencil text-plenoil-primary"></i></NavLink>
																</td>
															</tr>
														)
													}) }

													{ users.data && !users.data.length && <tr><td colSpan="100%">No hay datos disponibles</td></tr> }

													{ users.data === undefined && <TrSkeleton rows={skeletonRows} columns={6} /> }
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="col-md-12 text-center mb-3">
				<div className="d-inline-block">
					<Paginator
						min={1}
						current={users?.current_page}
						max={users?.last_page}
						changeCallback={(page) => setPage(page)}
					/>
				</div>
			</div>
		</LoggedLayout>
	);
}


